export let data = [
    {
        type : 'Cashew',
        content: 'The Energy Source High in magnesium and copper, cashews help convert food into energy and keep your bones strong.',
        image: '../assets/icons/cashew.jpg',
        price: '399'
    },
    {
        type: 'Almonds',
        content : 'The Glow Maker Rich in Vitamin E, these are your best friend for healthy skin and a strong immune system',
        image: '../assets/icons/almonds.jpg',
        price: '399'
    }, {
        type: 'Pumpkin',
        content: 'The Deep Sleeper One of the best natural sources of Magnesium and Tryptophan, which help regulate sleep and promote a calm mood. They are also packed with Zinc for a strong immune system',
        image: '../assets/icons/pumpkin.jpg',
        price: '399'
    }, {
        type: 'Walnuts',
        content: 'The Brain Booster Packed with Omega-3 fatty acids, walnuts support cognitive function and help keep your mind sharp',
        image: '../assets/icons/walnuts.jpg',
        price: '399'
    }, {
        type: 'Sunflower',
        content: 'The Skin Protector Loaded with Vitamin E, these seeds act as a powerful antioxidant that protects your cells from damage and keeps your skin looking youthful and glowing.',
        image: '../assets/icons/Sunflower2.jpg',
        price: '399'
    },
    {
        type: 'Pista',
        content: 'Great for eye health and weight management. They are lower in calories than most nuts and packed with antioxidants and potassium',
        image: '../assets/icons/pist.jpg',
        price: '399'
    },
    {
        type: 'Raisins',
        content: 'A natural energy booster that aids digestion. They are rich in iron and fiber, making them perfect for bone health and quick stamina',
        image: '../assets/icons/Raisins3.jpg',
        price: '100'
    },
    {
        type: 'Dry Dates',
        content: 'A massive energy and iron booster. Often added to winter milk or sweets to improve physical strength and hemoglobin levels',
        image: '../assets/icons/Dry Dates.jpg',
        price: '399'
    },
    {
        type: 'Anjeer',
        content: 'The ultimate digestive aid. High in fiber and calcium, they help with weight management and strengthening bones.',
        image: '../assets/icons/Dried Figs.jpg',
        price: '399'
    },
    {
        type: 'Peanuts',
        content: 'High in Biotin and protein. Great for hair and nail health, and provides a sustained energy boost.',
        image: '../assets/icons/Peanuts.jpg',
        price: '399'
    },
    {
        type: 'Makhana',
        content: 'A lightweight, "anti-aging" superfood. They are low in calories, high in protein, and excellent for kidney health and managing blood pressure',
        image: '../assets/icons/Makhana.jpg',
        price: '399'
    }

];
